module.exports = __webpack_public_path__ + "img/239.592350e2.jpg";